<!--<div class="text-3xl">Recommended Spaces</div>-->

<app-carousel2>

  <ng-container *ngFor="let location of list">
    <ng-container *carouselItem>
      <div>
        <app-location-card [location]="location"></app-location-card>
      </div>
    </ng-container>
  </ng-container>
</app-carousel2>